/*
 * This file is part of huoxin/filter-rule-manager.
 *
 * Copyright (c) 2026 huoxin.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
/**
 * Generic alert modal used by the FilterRulePopupDispatcher when a ruleset's
 * `displayMode` is `modal`. Shown once per ruleset firing — the dispatcher
 * tracks which ruleset IDs are already on screen so it doesn't re-open
 * the modal on every 300ms poll tick.
 */
export default class FilterRuleModal extends Modal {
  className() {
    const type = this.attrs.type || 'info';
    return "FilterRuleModal Modal--small FilterRuleModal--".concat(type);
  }
  title() {
    const type = this.attrs.type || 'info';
    const settings = this.attrs.displaySettings || {};
    if (settings.title) {
      return m.trust(settings.title);
    }
    return app.translator.trans("huoxin-filter-rule-manager.forum.modal_title_".concat(type));
  }
  content() {
    const type = this.attrs.type || 'info';
    const settings = this.attrs.displaySettings || {};
    let iconClass = settings.icon;
    if (!iconClass) {
      iconClass = type === 'block' ? 'fas fa-times-circle' : type === 'warning' ? 'fas fa-exclamation-triangle' : 'fas fa-info-circle';
    }
    const style = {};
    if (settings.textColor && settings.textColor !== 'transparent') style.color = settings.textColor;
    if (settings.backgroundColor && settings.backgroundColor !== 'transparent') style.backgroundColor = settings.backgroundColor;
    if (settings.backgroundColor === 'transparent') {
      style.backgroundColor = 'transparent';
      style.boxShadow = 'none';
      style.border = 'none';
    }
    const iconStyle = {};
    if (settings.iconColor && settings.iconColor !== 'transparent') iconStyle.color = settings.iconColor;
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "FilterRuleManager-FilterRuleModal-message FilterRuleManager-FilterRuleModal-message--".concat(type),
      style: style
    }, settings.icon !== 'none' && m(Icon, {
      name: iconClass,
      className: "FilterRuleManager-FilterRuleModal-icon",
      style: iconStyle
    }), m("span", {
      className: "FilterRuleManager-FilterRuleModal-text"
    }, m.trust(this.attrs.message))), m("div", {
      className: "Form-group FilterRuleManager-FilterRuleModal-actions"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.hide()
    }, app.translator.trans('huoxin-filter-rule-manager.forum.modal_ok'))));
  }
}
flarum.reg.add('huoxin-filter-rule-manager', 'forum/components/FilterRuleModal', FilterRuleModal);